import { Suspense, lazy } from 'react';
const Player = lazy(() => import('./player'));

type Props = {
    isFullscreen: boolean;
    isFauxFullscreen: boolean;
    toggleFullscreen: () => void;
};

export const VindralPlayer = ({
    isFullscreen,
    isFauxFullscreen,
    toggleFullscreen,
}: Props) => {
    return (
        <Suspense fallback={<div className="absolute inset-0 flex items-center justify-center bg-black/50 z-10">Loading...</div>}>
            <Player isFullscreen={isFullscreen} isFauxFullscreen={isFauxFullscreen} toggleFullscreen={toggleFullscreen} />
        </Suspense>
    );
};
